import { render, staticRenderFns } from "./QuanLyPhanQuyen.vue?vue&type=template&id=0cf48f84"
import script from "./QuanLyPhanQuyen.vue?vue&type=script&lang=js"
export * from "./QuanLyPhanQuyen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports